import { render } from "./AddProductPrepModal.vue?vue&type=template&id=864b153e"
import script from "./AddProductPrepModal.vue?vue&type=script&lang=js"
export * from "./AddProductPrepModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__